import InfoIcon from '@/shared/assets/icons/profile/personalInfo.svg?react'
import RateIcon from '@/shared/assets/icons/profile/personalRate.svg?react'
import SafeIcon from '@/shared/assets/icons/profile/personalSafe.svg?react'
import TimeZoneIcon from '@/shared/assets/icons/profile/personalTime.svg?react'
import SessionsIcon from '@/shared/assets/icons/profile/personarSessions.svg?react'
import { ProfileTabNames } from '../../../../../pages/panel/Profile'

type Props = {
  name: ProfileTabNames
}

export const ProfileIcon = ({ name }: Props) => {
  switch (name) {
    case 'info':
      return <InfoIcon />
    case 'safe':
      return <SafeIcon />
    case 'timeZone':
      return <TimeZoneIcon />
    case 'rate':
      return <RateIcon />
    case 'sessions':
      return <SessionsIcon />
  }
}
